<!-- COPEC Logo -->
<div class="flex items-center justify-center">
  <img src="assets/logo_icon.png" alt="Logo AI" class="h-5 -mt-1" />
  <img
    src="assets/images/copec_logo.png"
    alt="COPEC"
    class="h-4 opacity-80"
  />
</div>

<!-- App Title -->
<div class="w-full text-center mt-0">
  <h1 class="text-light-text dark:text-dark-text !mb-0">
    Bot Space
  </h1>
  <p class="small">
    Gerencia de Tecnología
  </p>
</div>
